import type { CompletionContext, CompletionResult } from "@codemirror/autocomplete";
import type { CompleteStrategy } from "@prometheus-io/codemirror-promql";

export type CompletionType =
	| "class"
	| "constant"
	| "enum"
	| "function"
	| "interface"
	| "keyword"
	| "method"
	| "namespace"
	| "property"
	| "text"
	| "type"
	| "variable";

/**
 * Custom completion strategy that filters out all suggestions except for the specified types.
 */
export class PromQLCompleteStrategy implements CompleteStrategy {
	public constructor(
		private readonly types: ReadonlySet<CompletionType>,
		private readonly baseStrategy: CompleteStrategy,
	) {}

	public async promQL(context: CompletionContext): Promise<CompletionResult | null> {
		const result = await Promise.resolve(this.baseStrategy.promQL(context));

		if (!result || this.types.size === 0) {
			return result;
		}

		const filteredOptions = result.options.filter(
			(option) => !option.type || this.types.has(option.type as CompletionType),
		);

		return {
			...result,
			options: filteredOptions,
		};
	}
}
